import React from 'react';

const TermsOfUseText = () => (
  <div className="GenericText__content">
    <h2>Terms of Use</h2>

    <p>
      <em>Updated: January 2017</em>
    </p>

    <p>
      Agreement with Terms and Conditions: This agreement
      (&quot;Agreement&quot;) sets forth the terms and conditions that apply to
      you (&quot;Visitor&quot;), an individual accessing the website
      Funbrain.com (&quot;Website&quot;) a property of Funbrain Holdings LLC
      (&ldquo;Funbrain&rdquo;). By accessing the Website, you agree to the
      following terms and conditions and the{' '}
      <a href="/privacy-policy.html">Privacy Statement</a>. If you do not agree,
      you have no right or license to access any part of the Website and you
      should not do so.
    </p>

    <h4>Changes in Terms and Conditions:</h4>

    <p>
      Funbrain&nbsp;has the right to change or discontinue any aspect or feature
      of the Website, including, but not limited to, content, hours of
      availability, and equipment needed for access or use, at any time.
      Funbrain has the right to change or modify the terms and conditions
      applicable to Visitor&#39;s use of the Website, or any part thereof, or to
      impose new conditions, including, but not limited to, adding fees and
      charges for use at any time. Such changes, modifications, additions or
      deletions shall be effective immediately upon notice thereof, which may be
      given by means including, but not limited to, posting on the Website, or
      by electronic or conventional mail, or by any other means by which Visitor
      obtains notice thereof. Any use of the Website by Visitor subsequent to
      such notice shall be deemed to constitute acceptance by Visitor of such
      changes, modifications or additions.
    </p>

    <h3>Conduct of Visitor:</h3>

    <h4>Lawful Use:</h4>

    <p>
      Visitor shall use the Website for lawful purposes only. Visitor shall not
      post or transmit through the Website any material which: (i) violates or
      infringes in any way upon the rights of others; (ii) is unlawful,
      threatening, abusive, defamatory, invasive of privacy or publicity rights,
      vulgar, obscene, profane or otherwise objectionable; (iii) encourages
      conduct that would constitute a criminal offense, gives rise to civil
      liability or otherwise violates any law; or (iv) contains advertising or
      any solicitation with respect to products or services, unless Funbrain has
      expressly approved such material in advance of its transmission. Any
      conduct by a Visitor that in Funbrain&#39;s discretion restricts or
      inhibits any other Visitor from using or enjoying the Website is expressly
      prohibited.
    </p>

    <h4>Downloading of Intellectual Property: </h4>

    <p>
      The Website contain copyrighted material, trademarks and other proprietary
      information, including, but not limited to, text, software, photos, video,
      graphics, music, and sound, portions of which are owned by Funbrain and
      portions of which are owned by other parties and licensed to Funbrain. The
      entire contents of the Website are copyrighted as a collective
      work/compilation. Funbrain owns copyright in the selection, coordination,
      arrangement, and enhancement of such content, as well as in the content
      original to it. No Visitor may modify, publish, transmit, participate in
      the transfer or sale, create derivative works, or in any way exploit, any
      of the content, in whole or in part. Except as otherwise expressly
      permitted under copyright law, no copying, redistribution, retransmission,
      publication or commercial exploitation of downloaded material will be
      permitted without the express written permission of Funbrain (or the
      copyright owner(s) if other than or in addition to Funbrain). In the event
      of any permitted copying, redistribution or publication of copyrighted
      material, no changes in or deletion of author attribution, trademark
      legend, copyright or other proprietary notice shall be made. Visitor
      acknowledges that he/she does not acquire any ownership rights by
      downloading copyrighted material.
    </p>

    <h4>Uploading of Intellectual Property: </h4>

    <p>
      Visitor shall not upload, post or otherwise make available on the Website
      any material protected by copyright, trademark, or other proprietary
      right, without the express written permission of the owner of the
      copyright, trademark, or other proprietary right, and the burden of
      determining that any material is not protected by copyright rests with
      Visitor. Visitor shall be solely liable for any damage resulting from any
      infringement of copyrights, proprietary rights, or any other harm
      resulting from such a submission. By submitting material to any public
      area of the Website, Visitor automatically grants, or warrants that the
      owner of such material has expressly granted, Funbrain the royalty-free,
      perpetual, irrevocable, non-exclusive right and license to use, reproduce,
      modify, adapt, publish, translate and distribute such material (in whole
      or in part) worldwide and/or to incorporate it in other works in any form,
      media or technology now known or hereafter developed for the full term of
      any copyright that may exist in such material. Visitor also permits any
      other Visitor to access, view, store or reproduce the material for that
      Visitor&#39;s personal use. Visitor hereby grants Funbrain the right to
      edit, copy, publish and distribute any material made available on the
      Website by Visitor.
    </p>

    <h4>Trademarks: </h4>

    <p>
      Unless otherwise indicated, trademarks that appear on this site are
      trademarks of Funbrain or its affiliates. All other trademarks not owned
      by Funbrain or its affiliates that appear on this site are the property of
      their respective owners, who may or may not be affiliated with, connected
      to, or sponsored by Funbrain or its affiliates.
    </p>

    <h3>Postings:</h3>

    <h4>No Responsibility or Liability: </h4>

    <p>
      To the extent that portions of the Website (such as comments sections on
      blog posts or message boards or share buttons for third party social media
      services, such as Facebook, Pinterest and Add This) provide users an
      opportunity to post and exchange information, ideas and opinions on
      Website or third party sites (&quot;Postings&quot;), BE ADVISED THAT
      FUNBRAIN DOES NOT SCREEN, EDIT, OR REVIEW POSTINGS PRIOR TO THEIR
      APPEARANCE ON THE Website OR ANY THIRD PARTY SITE, and Postings do not
      necessarily reflect the views of Funbrain. To the fullest extent permitted
      by applicable laws, Funbrain shall in no event have any responsibility or
      liability for the Postings or for any claims, damages, or losses resulting
      from their use and/or appearance on the Website or any third party site.
      Please note that third party sites and social media services have their
      own terms of use and privacy policies and Visitors should be aware of
      them.
    </p>

    <h4>Monitoring: </h4>

    <p>
      Funbrain&nbsp;reserves the right to monitor all Postings and to remove
      from the Website any Posting which Funbrain considers in its absolute
      discretion to be offensive or otherwise in breach of these terms and
      conditions.
    </p>

    <h4>Warrant that You Have All Necessary Rights: </h4>

    <p>
      You hereby represent and warrant that you have all necessary rights in and
      to all Postings you provide and all material they contain; that your
      Postings shall not infringe any proprietary or other rights of third
      parties; that your Postings shall not contain any viruses or other
      contaminating or destructive devices or features; that your Postings shall
      not contain any defamatory, indecent, offensive, tortious, or otherwise
      unlawful material or content; and that your Postings shall not be used to
      carry out or solicit any unlawful activity and/or be used to make
      commercial solicitations.
    </p>

    <h4>Authorize Others to Use: </h4>

    <p>
      You hereby authorize Funbrain to use and/or authorize others to use all or
      part of your Postings in any manner, format, or medium that Funbrain or
      such other parties see fit. You shall have no claim or other recourse
      against Funbrain for infringement of any proprietary right in Postings.
    </p>

    <h3>Disclaimers and Limitation of Liability:</h3>

    <h4>Use Is At Visitor&#39;s Risk: </h4>

    <p>
      VISITOR EXPRESSLY AGREES THAT USE OF THE WEBSITE IS AT VISITOR&#39;S OWN
      RISK. VISITOR SHALL BE RESPONSIBLE FOR PROTECTING THE CONFIDENTIALITY OF
      VISITOR&#39;S PASSWORD(S), IF ANY. NEITHER FUNBRAIN, ITS AFFILIATES, NOR
      ANY OF THEIR RESPECTIVE EMPLOYEES, SHAREHOLDERS, AGENTS, THIRD-PARTY
      CONTENT PROVIDERS OR LICENSORS, WARRANT THAT THE WEBSITE WILL BE
      UNINTERRUPTED OR ERROR FREE; NOR DO THEY MAKE ANY WARRANTY AS TO THE
      RESULTS THAT MAY BE OBTAINED FROM USE OF THE WEBSITE, OR AS TO THE
      ACCURACY, RELIABILITY OR CONTENT OF ANY INFORMATION, SERVICE, OR
      MERCHANDISE PROVIDED THROUGH THE WEBSITE. PRICE INFORMATION IS SUBJECT TO
      CHANGE WITHOUT NOTICE. IT IS YOUR RESPONSIBILITY TO EVALUATE THE ACCURACY
      AND COMPLETENESS OF ALL INFORMATION, OPINIONS AND OTHER MATERIAL ON THE
      Website OR ANY SITES WITH WHICH IT IS LINKED. FUNBRAIN PROVIDES TECHNOLOGY
      AUTOMATICALLY PRODUCING SEARCH RESULTS THAT LINK AND/OR REFERENCE SITES
      AND INFORMATION LOCATED WORLDWIDE THROUGHOUT THE INTERNET. BECAUSE WE HAVE
      NO CONTROL OVER SUCH SITES AND INFORMATION, FUNBRAIN MAKES NO GUARANTEE AS
      TO SUCH SITES AND INFORMATION, INCLUDING THE ACCURACY, CURRENCY, CONTENT
      OR QUALITY OF ANY SUCH SITES AND INFORMATION AND FUNBRAIN ASSUMES NO
      RESPONSIBILITY AS TO WHETHER THE SEARCH LOCATES UNINTENDED OR
      OBJECTIONABLE CONTENT. FURTHERMORE, BECAUSE SOME CONTENT ON THE INTERNET
      CONSISTS OF MATERIAL THAT IS ADULT-ORIENTED OR OTHERWISE OBJECTIONABLE TO
      SOME PEOPLE, THE RESULTS OF YOUR SEARCH ON OUR SITES MAY AUTOMATICALLY AND
      UNINTENTIONALLY GENERATE LINKS OR REFERENCES TO OBJECTIONABLE MATERIAL. WE
      MAKE NO CLAIM THAT SUCH SURPRISES MIGHT NOT OCCUR.
    </p>

    <h4>No Warranties of Service: </h4>

    <p>
      THE WEBSITE IS PROVIDED ON AN &quot;AS IS&quot; BASIS WITHOUT WARRANTIES
      OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO,
      WARRANTIES OF TITLE OR IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS
      FOR A PARTICULAR PURPOSE, OTHER THAN THOSE WARRANTIES WHICH ARE INCAPABLE
      OF EXCLUSION, RESTRICTION OR MODIFICATION UNDER THE LAWS APPLICABLE TO
      THIS AGREEMENT.
    </p>

    <h4>Disclaimer of Liability: </h4>

    <p>
      THIS DISCLAIMER OF LIABILITY APPLIES TO ANY DAMAGES OR INJURY CAUSED BY
      ANY FAILURE OF PERFORMANCE, ERROR, OMISSION, INTERRUPTION, DELETION,
      DEFECT, DELAY IN OPERATION OR TRANSMISSION, COMPUTER VIRUS, COMMUNICATION
      LINE FAILURE, THEFT OR DESTRUCTION OR UNAUTHORIZED ACCESS TO, ALTERATION
      OF, OR USE OF RECORD, WHETHER FOR BREACH OF CONTRACT, TORTIOUS BEHAVIOR,
      NEGLIGENCE, OR UNDER ANY OTHER CAUSE OF ACTION. VISITOR SPECIFICALLY
      ACKNOWLEDGES THAT FUNBRAIN AND ITS LICENSORS ARE NOT LIABLE FOR THE
      DEFAMATORY, OFFENSIVE OR ILLEGAL CONDUCT OF OTHER VISITORS OR THIRD
      PARTIES AND THAT THE RISK OF INJURY FROM THE FOREGOING RESTS ENTIRELY WITH
      VISITOR.
    </p>

    <h4>Visitor&#39;s Waiver of Damages: </h4>

    <p>
      IN NO EVENT WILL FUNBRAIN, OR ANY PERSON OR ENTITY INVOLVED IN CREATING,
      PRODUCING OR DISTRIBUTING ANY PART OF THE WEBSITE BE LIABLE FOR ANY
      DAMAGES, INCLUDING, WITHOUT LIMITATION, DIRECT, INDIRECT, INCIDENTAL,
      SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES ARISING OUT OF THE USE OF OR
      INABILITY TO USE ANY PART OF THE WEBSITE. VISITOR HEREBY ACKNOWLEDGES THAT
      THE PROVISIONS OF THIS SECTION SHALL APPLY TO ALL CONTENT ON ALL WEBSITE.
    </p>

    <p>
      IN ADDITION TO THE TERMS SET FORTH ABOVE, NEITHER FUNBRAIN, NOR ITS
      AFFILIATES, INFORMATION PROVIDERS OR CONTENT PARTNERS SHALL BE LIABLE
      REGARDLESS OF THE CAUSE OR DURATION, FOR ANY ERRORS, INACCURACIES,
      OMISSIONS, OR OTHER DEFECTS IN, OR UNTIMELINESS OR INAUTHENTICITY OF, THE
      INFORMATION CONTAINED WITHIN THE WEBSITE, OR FOR ANY DELAY OR INTERRUPTION
      IN THE TRANSMISSION THEREOF TO THE VISITOR, OR FOR ANY CLAIMS OR LOSSES
      ARISING THEREFROM OR OCCASIONED THEREBY. NONE OF THE FOREGOING PARTIES
      SHALL BE LIABLE FOR ANY THIRD-PARTY CLAIMS OR LOSSES OF ANY NATURE,
      INCLUDING, BUT NOT LIMITED TO, LOST PROFITS, PUNITIVE OR CONSEQUENTIAL
      DAMAGES.
    </p>

    <h4>Indemnification: </h4>

    <p>
      Visitor agrees to defend, indemnify and hold harmless Funbrain, its
      affiliates and their respective directors, officers, shareholders,
      employees, agents, and assigns from and against all claims and expenses,
      including attorneys&#39; fees, arising out of Visitor&#39;s use of the
      Website.
    </p>

    <h4>Equipment for Visitor&#39;s Use:</h4>

    <p>
      Visitor shall be responsible for obtaining and maintaining all telephones,
      computer hardware, and other equipment needed for access to and use of the
      Website and for any/all charges related thereto.
    </p>

    <h4>Website&#39; Content: </h4>

    <p>
      Certain content portions of the Website are supplied by third parties. Any
      opinions, advice, statements, services, offers, or other information or
      content expressed or made available by third parties, including
      information providers, are those of the respective author(s) or
      distributor(s) and not of Funbrain. Neither Funbrain nor any third-party
      provider of information guarantees the accuracy, completeness, or
      usefulness of any content, nor its merchantability or fitness for any
      particular purpose. Funbrain neither endorses nor is responsible for the
      accuracy or reliability of any opinion, advice or statement made on the
      Website by anyone other than employee spokespersons of Funbrain while
      acting in their official capacities.
    </p>

    <h4>Submissions: </h4>

    <p>
      Funbrain&nbsp;always welcomes suggestions and comments regarding the
      Website. Any comments or suggestions submitted to Website or Funbrain,
      either online or offline, will become Funbrain&#39;s property upon their
      submission. This policy is intended to avoid the possibility of future
      misunderstandings when projects developed by Funbrain might seem to others
      to be similar to their own submissions or comments.
    </p>

    <h4>Entire Agreement: </h4>

    <p>
      This Agreement, and any operating rules for the Website established by
      Funbrain, constitutes the entire agreement of the parties with respect to
      the subject matter hereof, and supersedes all previous written or oral
      agreements between the parties with respect to such subject matter.
    </p>

    <h4>Controlling Law: </h4>

    <p>
      This Agreement shall be construed in accordance with the laws of the State
      of New York, without regard to its conflict of laws rules. Any cause of
      action of any nature arising out this Agreement shall be brought in the
      City and County of New York.
    </p>

    <h4>Headings: </h4>

    <p>
      The section headings used herein are for convenience only and shall not be
      given any legal import whatsoever.
    </p>

    <h4>Digital Millennium Copyright Act Compliance: </h4>

    <p>
      If you have copyright concerns about any materials posted on this site by
      others, please let us know. We comply with the provisions of the Digital
      Millennium Copyright Act applicable to Internet service providers (17
      U.S.C. &sect; 512). If you have any complaints or objections to material
      posted on this site, please contact our Designated Agent
      (&quot;Notice&quot;):
    </p>

    <h3>Designated Agent</h3>

    <p>
      FUNBRAIN HOLDINGS LLC
      <br />
      540 Atlantic Avenue, 5th Floor
      <br />
      Brooklyn, NY 11217
    </p>

    <p>
      Or, you can click here to email us about any copyright concerns about any
      materials posted on this site by others.
    </p>

    <p>To be effective, the Notice must include the following:</p>

    <ul>
      <li>
        A physical or electronic signature of the owner or a person authorized
        to act on behalf of the owner (&quot;Complaining Party&quot;) of an
        exclusive right that is allegedly infringed;
      </li>

      <li>
        Identification of the copyrighted work claimed to have been infringed,
        or if multiple copyrighted works at the Website are covered by a single
        notification, a representative list of such works at that site;
      </li>

      <li>
        Identification of the material that is claimed to be infringing or to be
        the subject of infringing activity and that is to be removed or access
        to which is to be disabled, and information reasonably sufficient to
        permit Funbrain to locate the material;
      </li>

      <li>
        Information reasonably sufficient to permit Funbrain to contact the
        Complaining Party, such as an address, telephone number, and if
        available, an electronic mail address at which the Complaining Party may
        be contacted;
      </li>

      <li>
        A statement that the Complaining Party has a good faith belief that use
        of the material in the manner complained of is not authorized by the
        copyright owner, its agent, or the law; and
      </li>

      <li>
        A statement that the information in the notification is accurate, and
        under penalty of perjury, that the Complaining Party is the owner or is
        authorized to act on behalf of the owner of an exclusive right that is
        allegedly infringed.
      </li>
    </ul>

    <p>
      If you have questions or concerns about your account, please contact
      Customer Support at:{' '}
      <a href="mailto:help@funbrain.com">help@funbrain.com</a>.
    </p>
  </div>
);

export default TermsOfUseText;
